export class SharedData {
  UserID: string;
  Module: string;
  ContactType: string;
  SessionParamterString: string;
  iframeID: string;
  isMultipleContact: boolean;
  isContactSaved: boolean;
}
